import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { COLORS } from '../../constants';
import { OBJECTIVES } from '../../lib/kitLogic';

const RecommendPicker = ({ onPick, onClose }) => {
  const { t } = useLanguage();
  return (
    <motion.div className="recommend" initial={{ opacity: 0, y: -8, height: 0 }} animate={{ opacity: 1, y: 0, height: 'auto' }} exit={{ opacity: 0, y: -6, height: 0 }} transition={{ duration: 0.25 }} data-testid="recommend-picker">
      <div className="recommend-inner">
        <div className="recommend-head">
          <strong>{t('home.mix.recommend_title')}</strong>
          <button onClick={onClose} className="recommend-close" aria-label={t('share.close')} data-testid="recommend-close">✕</button>
        </div>
        <div className="recommend-chips">
          {OBJECTIVES.map((o) => (
            <button key={o.id} onClick={() => onPick(o)} className="recommend-chip" style={{ '--line': COLORS[o.color] }} data-testid={`recommend-${o.id}`}>
              <i />{t(`home.mix.objectives.${o.id}`)}
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default RecommendPicker;
